import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import { useQuery } from '@tanstack/react-query';

import * as OPTIONS from "../option-fields";
import * as QUERIES from "../query-functions";
import * as UTILS from "../utils";

import LoadingIndicator from '../components/loading-indicator';
import AddToCalendarButton from '../components/add-to-calendar-button';

export default function OrderConfirmation(props) {

    const [latestOrder, setLatestOrder] = useState(null);

    const { 
        isFetching: ordersFetching,
        isPending: ordersPending,
        data: ordersData,
    } = useQuery({
        queryKey: ['ordersData'],
        queryFn: QUERIES.getOrders,
        refetchOnWindowFocus: false,
        retry: false
    });

    useEffect(() => {
        if (!ordersData) return;

        const latest_order = UTILS.findClosestDate(ordersData, "firstTransactionDate");
        setLatestOrder(latest_order);
    }, [ordersData])

    return (
        <div className='booking-pathway__container booking-pathway__order-confirmation'>

            <div className='booking-pathway__main-content'>
                <h1 className='sr-text'>Your order is complete.</h1>
                {OPTIONS.orderConfimation.introduction?.innerHTML &&
                    <div className='booking-pathway__header' dangerouslySetInnerHTML={{__html: OPTIONS.orderConfimation.introduction.innerHTML}}></div>
                }
                {OPTIONS.orderConfimation.button?.innerHTML &&
                    <div className='booking-pathway__order-confirmation--button' dangerouslySetInnerHTML={{__html: OPTIONS.orderConfimation.button.innerHTML}}></div>
                }
                {OPTIONS.orderConfimation.images?.innerHTML &&                
                    <div className='booking-pathway__order-confirmation--images' dangerouslySetInnerHTML={{__html: OPTIONS.orderConfimation.images.innerHTML}}></div>
                }
            </div>

            <div className='booking-pathway__summary'>
                {ordersPending || ordersFetching || latestOrder == null ?
                    <LoadingIndicator />
                : latestOrder ? 
                (
                    <>
                        {latestOrder.donations?.map((donation) => (
                            <div key={donation.id} className='confirmed-order confirmed-order__donation'>
                                <h2 className='confirmed-order__header'>{donation.fund.name}</h2>
                                <p>{`Thank you for your donation for £${donation.amount.toFixed(2)}.`}</p>
                            </div>
                        ))}
                
                        {latestOrder.tickets?.map((ticket) => {
                            const formattedDate = UTILS.formatDateTime(ticket.instance.start);
                            return (
                                <div key={ticket.id} className='confirmed-order confirmed-order__ticket'>
                                    <h2 className='confirmed-order__header'>{ticket.event.name}</h2>
                                    <p className="instance-event-summary__date">{formattedDate}</p>
                                    <p className="instance-event-summary__venue">{ticket.event?.attribute_FestivalKingsStudio}</p>
                                    <AddToCalendarButton ticket={ticket}  />
                                </div>
                            )
                        })}
                
                        {latestOrder.membershipSubscription?.map((membership) => (
                                <div key={membership.id} className='confirmed-order confirmed-order__membership'>
                                    <h2 className='confirmed-order__header'>{membership.membership.name}</h2>
                                    <p>Thank you for joining Capital Theatres.</p>
                                </div>
                        ))}
                    </>
                )
                    : null
                }

            </div>
        </div>
    );
}